import React, { Component } from 'react';
import axios from 'axios';
import config from '../Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagramSquare } from '@fortawesome/free-brands-svg-icons';

class InstaFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            media: [],
            error: null,
        };
    }

    componentDidMount() {
        this.fetchInstagramMedia();
    }

    fetchInstagramMedia = async () => {
        const accessToken = config.token;
        const apiUrl = `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink&limit=4&access_token=${accessToken}`;

        try {
            const response = await axios.get(apiUrl);
            this.setState({ media: response.data.data });
        } catch (error) {
            this.setState({ error: 'Errore nel recupero dei dati da Instagram' });
        }
    };

    render() {
        const { media, error } = this.state;

        return (
            <div className='content-wrapper m-c p-tb-5'>
                <div className='animated-item fade-in-slide-up delay-2 content-wrapper m-c b-light t-a-c'>
                    <div className='p-2 border-item'>
                        <h4 className='uppercase ervasera animated-item fade-in-slide-up'>Riflessi di Emozioni</h4>
                        <p className='m-t-1  animated-item fade-in-slide-up delay-1'>Segui il mio mondo su Instagram</p>
                    
                        {error ? (
                            <p>{error}</p>
                        ) : (
                            <ul className='m-t-1'>
                                {media.map((item) => (
                                    <li key={item.id} className='p-1 c-25 d-i-b v-a-t sm-c-50 sm-p-01'>
                                        <a href={item.permalink} target="_blank" rel="noopener noreferrer">
                                            {item.media_type === 'IMAGE' || item.media_type === 'CAROUSEL_ALBUM' ? (
                                                <img className='c-100 d-b' src={item.media_url} alt={item.caption || 'Instagram media'}/>
                                            ) : item.media_type === 'VIDEO' ? (
                                                <video className='c-100 d-b'  controls>
                                                    <source src={item.media_url} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : null}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        )}
                        <div className='p-1 m-t-2'>
                            <a href={config.instagram_url} target='_blank' className='d-b t-a-c m-c m-tb-1 b-primary c-light p-1 sans-serif-bold uppercase'>
                                Seguimi su instagram
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InstaFeed;
